module.exports = __webpack_public_path__ + "media/bootstrap-icons/unlock-153fd71a.svg";